import React from 'react';
import { useTranslation } from 'react-i18next';

import { Title } from 'app/SharedComponents';
import { ModalInfo } from 'app/SharedComponents/Modal';

const ErrorBoundaryFallback = () => {
  const { t } = useTranslation();

  const handleClick = () => {
    window.location.reload();
  };

  return (
    <ModalInfo
      withButton
      isOpen={true}
      buttonText={t('close')}
      onButtonClick={handleClick}
    >
      <Title
        level={4}
        data-testid="error-title"
        className="font-medium text-typo-title dark:text-grayscale-lighter mb-4"
      >
        {t('commonModalErrorTitle')}
      </Title>
      <p className="text-typo-normal dark:text-grayscale-lighter">
        {t('commonModalErrorDescription')}
      </p>
    </ModalInfo>
  );
};
export default ErrorBoundaryFallback;
